import React, { useState, useEffect, useCallback } from "react";
import FilterSelector from "./FilterSelector";

// Компонент модалки з фільтрами
const FilterModal = React.memo(({ isOpen, onClose, filters, onApply }) => {
  const [tempValues, setTempValues] = useState({});

  // Оновлюємо tempValues при відкритті модалки
  useEffect(() => {
    if (isOpen) {
      const initialValues = {};
      filters.forEach((f) => {
        // Використовуємо ID як ключ
        initialValues[f.id] = f.value;
      });
      setTempValues(initialValues);
    }
  }, [isOpen, filters]);

  // Обробка змін у локальному стані
  const handleLocalChange = (id, newValue) => {
    setTempValues((prev) => ({
      ...prev,
      [id]: newValue,
    }));
  };

  // Обробка застосування фільтрів
  const handleApply = useCallback(() => {
    // Передаємо об'єкт { shop_id: 1, category_id: 2 }
    onApply(tempValues);
    onClose();
  }, [tempValues, onApply, onClose]);

  // Обробка скидання фільтрів
  const handleReset = useCallback(() => {
    // Передаємо об'єкт { shop_id: null, category_id: null }
    const resetValues = {};
    filters.forEach((f) => {
      resetValues[f.id] = null;
    });
    setTempValues(resetValues);

    onApply(resetValues);
    onClose();
  }, [filters, onApply, onClose]);

  // Якщо модальне вікно закрито, повертаємо null
  if (!isOpen) return null;

  // Перевірка на наявність незастосованих змін
  const hasChanges = filters.some((f) => tempValues[f.id] !== f.value);
  // Перевірка на наявність фільтрів щоб їх скинути
  const hasFiltersAppliedInModal = Object.values(tempValues).some(
    (v) =>
      v !== null && v !== undefined && (typeof v === "string" ? v.trim() !== "" : true)
  );

  // блокуємо вспливання bubbling по DOM
  const stopPropagation = (e) => e.stopPropagation();

  return (
    <div className="filter-modal" onClick={onClose}>
      <div className="modal-content" onClick={stopPropagation}>
        <header className="modal-header">
          <h4>Фільтри</h4>
        </header>
        <div className="modal-body">
          {filters.map((filterConfig) => (
            <div className="filter-group" key={filterConfig.id}>
              <label htmlFor={filterConfig.id}>{filterConfig.label}</label>
              <FilterSelector
                type={filterConfig.type || "select"}
                options={filterConfig.options}
                value={tempValues[filterConfig.id] ?? null}
                onChange={(newValue) => handleLocalChange(filterConfig.id, newValue)}
                placeholder={filterConfig.placeholder}
                valueKey={filterConfig.valueKey}
                labelKey={filterConfig.labelKey}
                multiple={filterConfig.multiple || false}
                isHierarchical={filterConfig.isHierarchical}
              />
            </div>
          ))}
        </div>
        <footer className="modal-footer">
          <button onClick={handleReset} disabled={!hasFiltersAppliedInModal}>
            Скинути фільтри
          </button>
          <button className="focus-button" onClick={handleApply} disabled={!hasChanges}>
            Застосувати
          </button>
        </footer>
      </div>
    </div>
  );
});

export default FilterModal;
